function label(text, layer) {
  const el = document.getElementById("label");
  while (el.firstChild) {
    el.firstChild.remove();
  }
  text ? (el.innerHTML = `${text}`) : "";
}
export default label;
